import Layout from '@/layout/Layout.vue'

export default {
  path: '/',
  name: '数据可视化',
  component: Layout,
  redirect: '/dashboard',
  children: [
    {
      name: '仪表盘',
      path: 'dashboard',
      component: () => import('@/views/dashboard/dashboard/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'dashboard'
      }
    },
    {
      name: '实时数据',
      path: 'constantlyData',
      component: () => import('@/views/dashboard/constantlyData/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'constantlyData'
      }
    },
    {
      name: '事件分析',
      path: 'eventStudy',
      component: () => import('@/views/dashboard/eventStudy/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'eventStudy'
      }
    }
  ]
}
